import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain, ManageNotification, Page,
} from '../../components';
import config from '../../config';

interface Props {
  intl: any;
  scrollingDisabled: any;
}

const ManageNotificationComponent: React.FC<Props> = (props: Props) => {
  const { intl, scrollingDisabled } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'Rolemanagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain>
        <div>
          <ManageNotification />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const ManageNotificationComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(ManageNotificationComponent);

export default ManageNotificationComponentPage;
